module.exports = __webpack_public_path__ + "8adfddc684bc8e7af565083af2b84d34.jpg";